// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__jJuV8","content":"LoadingAlert_content__2teUp"};